<template>
  <div :id="'multi-data' + rowNumber" class="mb-5">
    <ReportHeader
      :reportTypeId="reportTypeId"
      :title="title"
      :subtitle="subtitle"
    />
    <div class="row">
      <div class="col pb-3">
        <div :id="chartID"></div>
        <div style="display: none">
          <img :id="chartID + 'ChartImg'" src="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ReportHeader from '~/components/report/ReportHeader.vue';
  export default {
    name: 'MultiDataComponent',
    components: {
      ReportHeader,
    },
    props: {
      companyName: String,
      consulting_slug: String,
      multiDT: Object,
      rowNumber: Number,
      fiscalYearEndMonth: Number,
      chartID: String,
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
    },
    data() {
      return {
        multiDTColors: [
          '#006742',
          '#2CF2A5',
          '#87CFF3',
          '#A9DCD6',
          '#CC4B4C',
          '#F6712E',
          '#F8E328',
          '#09A684',
          '#183961',
          '#5AB5A2',
          '#65A9D2',
        ],
        firstLoad: true,
        monthYear: [],
      };
    },
    computed: {
      title() {
        return `${this.multiDT.ChartTitle}`;
      },
      subtitle() {
        return ``;
      },
    },
    mounted() {
      this.plotChart(true);
    },
    methods: {
      async pushToImage() {
        // await this.plotChart().then( async () => {
        return await Plotly.toImage(this.chartID, {
          format: 'png',
          width: 1000,
          height: 800,
        });
      },
      plotChart: function (firstLoad) {
        this.firstLoad = firstLoad;
        if (!this.firstLoad) {
          document
            .getElementById(this.chartID)
            .classList.contains('js-plotly-plot')
            ? document
                .getElementById(this.chartID)
                .classList.remove('js-plotly-plot')
            : '';
          document.getElementById(this.chartID).innerHTML = '';
        }

        this.monthYear = [];
        for (let i = 0; i < this.multiDT.MonthYear.length; i++) {
          var date = this.multiDT.MonthYear[i];
          if (this.firstLoad && this.multiDT.DataShift != 0) {
            var newDate = new Date(date);
            var year = newDate.getFullYear();
            this.monthYear.push(
              new Date(
                year + this.multiDT.DataShift,
                newDate.getMonth(),
                newDate.getDate()
              )
            );
          } else {
            this.monthYear.push(date);
          }
        }

        var fyTickSettings = '';
        if (this.firstLoad && this.multiDT.DataShift != 0) {
          var tmpSettings = this.multiDT.FiscalYearTickSetting;
          var tmpYear =
            parseInt(tmpSettings.slice(0, 4)) + this.multiDT.DataShift;
          fyTickSettings = tmpYear + tmpSettings.slice(4, tmpSettings.length);
        } else {
          fyTickSettings = this.multiDT.FiscalYearTickSetting;
        }

        let ssHistorical = {
          type: 'scatter',
          mode: 'scatter',
          x: this.monthYear,
          y: this.multiDT.SubjectHistoricData,
          name: this.multiDT.SubjectTitle + ' - ' + this.multiDT.SubjectMetric,
          line: {
            width: 4,
            color: '#183961',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: false,
        };

        // //example new plot for Evp-addon
        let ssfUMR = {
          mode: 'lines',
          legendgroup:
            this.multiDT.SubjectTitle +
            ' Forecast - ' +
            this.multiDT.SubjectMetric,
          x: this.monthYear,
          //only need to change the y data, x is consistent throughout
          y: this.multiDT.SubjectForecastUMR,
          name:
            this.multiDT.SubjectTitle +
            ' Forecast - ' +
            this.multiDT.SubjectMetric,
          line: {
            width: 4,
            color: '#183961',
            dash: 'dashdot',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: false,
        };

        let ssfLMR = {
          mode: 'lines',
          legendgroup:
            this.multiDT.SubjectTitle +
            ' Forecast - ' +
            this.multiDT.SubjectMetric,
          showlegend: false,
          x: this.monthYear,
          //only need to change the y data, x is consistent throughout
          y: this.multiDT.SubjectForecastLMR,
          name:
            this.multiDT.SubjectTitle +
            ' Forecast - ' +
            this.multiDT.SubjectMetric,
          line: {
            width: 4,
            color: '#183961',
            dash: 'dashdot',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: false,
        };

        for (let i = 0; i < this.monthYear.length; ++i) {
          if (this.multiDT.SubjectForecastUMR[i]) {
            ssfUMR.visible = true;
          }
          if (this.multiDT.SubjectForecastLMR[i]) {
            ssfLMR.visible = true;
          }
          if (this.multiDT.SubjectHistoricData[i]) {
            ssHistorical.visible = true;
          }
        }

        //array of all traces to plot
        //change based on if evp series or not
        let chartData = [ssHistorical, ssfUMR, ssfLMR];

        // loop through indicator info
        for (let i = 0; i < this.multiDT.IndicatorInfo.length; ++i) {
          const row = this.multiDT.IndicatorInfo[i];
          let historical = {
            type: 'scatter',
            mode: 'scatter',
            x: this.monthYear,
            y: row.HistoricData,
            name: row.SeriesName + ' - ' + row.Metric,
            line: {
              width: 4,
              color: this.multiDTColors[i],
            },
            yaxis: 'y2',
            xaxis: 'x',
            visible: true,
          };

          //example new plot for Evp-addon
          let forecast = {
            // type: 'scatter',
            showlegend: false,
            mode: 'markers',
            x: this.monthYear,
            //only need to change the y data, x is consistent throughout
            y: row.ForecastData,
            name: row.SeriesName + ' Forecast - ' + row.Metric,
            line: {
              width: 4,
              color: this.multiDTColors[i],
            },
            yaxis: 'y2',
            xaxis: 'x',
            visible: false,
          };
          for (let x = 0; x < this.monthYear.length; ++x) {
            if (row.ForecastData[x]) {
              forecast.visible = true;
              forecast.showlegend = true;
            }
          }
          chartData.push(historical, forecast);
        }

        const layout = {
          showlegend: true,
          autosize: true,
          legend: {
            orientation: 'h',
            y: 1.6,
            x: 0.5,
            xanchor: 'center',
            // yanchor: 'middle',
            // valign: 'middle',
            traceorder: 'normal',
            bgcolor: '#fff',
            bordercolor: '#444',
            borderwidth: 0,
            font: {
              family: '\\"Open Sans\\", sans-serif',
            },
          },
          modebar: {
            orientation: 'v',
          },
          dragmode: 'zoom',
          yaxis: {
            title: '' + this.multiDT.SubjectDataType,
            mirror: true,
            anchor: 'x',
            family: '\\"Open Sans\\", sans-serif',
            size: 12,
            color: '#444',
            ticks: 'outside',
            automargin: true,
          },
          yaxis2: {
            title: 'Indicators',
            showgrid: false,
            overlaying: 'y',
            anchor: 'x',
            side: 'right',
            family: '\\"Open Sans\\", sans-serif',
            size: 12,
            color: '#444',
            ticks: 'outside',
            zeroline: false,
            automargin: true,
          },
          xaxis: {
            dtick: 'M24',
            ticks: 'outside',
            automargin: true,
            showline: true,
            showgrid: false,
            tick0: fyTickSettings,
            tickformat: '%Y',
            hoverformat: '%b %Y',
          },
          family: '\\"Open Sans\\", sans-serif',
          size: 12,
          color: '#444',
          height: 800,
          margin: {
            t: 50,
            l: 50,
            r: 50,
            b: 50,
          },
        };

        Plotly.react(this.chartID, chartData, layout, {
          responsive: true,
          displaylogo: false,
          modeBarButtonsToRemove: [
            'autoScale2d',
            'toImage',
            'sendDataToCloud',
            'lasso2d',
            'toggleSpikelines',
            'resetScale2d',
          ],
          doubleClick: false /*'reset'*/,
        }).then((chartData) => {
          this.adjustChart(chartData);
          document
            .getElementById(this.chartID)
            .on('plotly_relayout', (eventData) => {
              this.adjustChart(
                document.getElementById(this.chartID),
                eventData
              );
            });
        });
      },
      adjustChart: function (chartData = null, eventData = null) {
        const axisZoomedIn =
          eventData !== null && eventData['xaxis.range[0]'] ? true : false;
        let layoutObject = this.getTableRanges(
          chartData,
          axisZoomedIn,
          eventData
        );

        if (axisZoomedIn) {
          layoutObject['xaxis.range'] = chartData.layout.xaxis.range;
          layoutObject['xaxis.dtick'] = 'M12';
        } else {
          layoutObject['xaxis.range'] = [
            this.monthYear[0],
            this.monthYear[this.monthYear.length - 1],
          ];
          layoutObject['xaxis.dtick'] = 'M24';
        }

        Plotly.update(this.chartID, null, layoutObject).then(() => {
          var dataShift = this.multiDT.DataShift;
          if (dataShift !== 0) {
            Plotly.d3
              .selectAll(`#${this.chartID} .xtick text`)
              .each(function (d, i) {
                var x = Plotly.d3.select(this).html();
                if (x.length > 0) {
                  var date = parseInt(x);
                  Plotly.d3.select(this).html(date + dataShift);
                }
              });
          }

          if ($('#' + this.chartID + 'ChartImg').attr('src') === '') {
            Plotly.toImage(chartData, { height: 600, width: 800 }).then(
              (url) => {
                $('#' + this.chartID + 'ChartImg').attr('src', url);
                this.firstLoad = false;
                this.plotChart(false);
              }
            );
          }
        });
      },
      getTableRanges: function (
        chartObject = [],
        axisZoomedIn = false,
        axisEventObject = [],
        matchTraces = false
      ) {
        const rows = chartObject.data;
        let y1Axis = rows.filter((row) => {
          if (
            row !== undefined &&
            row.y.length > 0 &&
            row.yaxis === 'y' &&
            row.visible
          ) {
            return row;
          }
        });

        var y1AllMin = y1Axis.map((row) => {
          const min = Math.min.apply(
            Math,
            row.y.filter((o) => {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );

          if (min !== undefined) {
            return min;
          }
        });

        var y1AllMax = y1Axis.map((row) => {
          const max = Math.max.apply(
            Math,
            row.y.filter((o) => {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );

          if (max !== undefined) {
            return max;
          }
        });

        let y1_min = Math.min.apply(
          Math,
          y1AllMin.filter(function (o) {
            if (o !== '') {
              return parseFloat(o);
            }
          })
        );

        let y1_max = Math.max.apply(
          Math,
          y1AllMax.filter(function (o) {
            if (o !== '') {
              return parseFloat(o);
            }
          })
        );

        let y2Axis = rows.filter((row) => {
          if (
            row !== undefined &&
            row.y.length > 0 &&
            row.yaxis === 'y2' &&
            row.visible
          ) {
            return row;
          }
        });

        var y2AllMin = y2Axis.map((row) => {
          const min = Math.min.apply(
            Math,
            row.y.filter((o) => {
              if (o !== '' && o !== Infinity && o !== -Infinity) {
                return parseFloat(o);
              } else {
                return -1;
              }
            })
          );

          if (min !== undefined) {
            return min;
          }
        });

        var y2AllMax = y2Axis.map((row) => {
          const max = Math.max.apply(
            Math,
            row.y.filter((o) => {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );

          if (max !== undefined) {
            return max;
          }
        });

        let y2_min;
        let y2_max;

        if (y2AllMin.length > 0) {
          y2_min = Math.min.apply(
            Math,
            y2AllMin.filter(function (o) {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );
        } else {
          y2_min = y1_min;
        }

        if (y2AllMax.length > 0) {
          y2_max = Math.max.apply(
            Math,
            y2AllMax.filter(function (o) {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );
        } else {
          y2_max = y1_max;
        }

        if (y2_min === Infinity || y2_min === -Infinity) {
          y2_min = -1;
        }

        if (y2_max === Infinity || y2_max === -Infinity) {
          y2_max = 1;
        }

        if (y2_min < 0 && y2_min > -1) {
          y2_min = -1;
        }

        if (y2_max > -1 && y2_max < 1) {
          y2_max = 1;
        }

        if (matchTraces) {
          if (y1_min < y2_min) {
            y2_min = y1_min;
          } else {
            y1_min = y2_min;
          }

          if (y1_max > y2_max) {
            y2_max = y1_max;
          } else {
            y1_max = y2_max;
          }
        }

        if (axisZoomedIn) {
          if (axisEventObject['yaxis.range[0]']) {
            y1_min = axisEventObject['yaxis.range[0]'];
          }

          if (axisEventObject['yaxis.range[1]']) {
            y1_max = axisEventObject['yaxis.range[1]'];
          }

          if (axisEventObject['yaxis2.range[0]']) {
            y2_min = axisEventObject['yaxis2.range[0]'];
          }

          if (axisEventObject['yaxis2.range[1]']) {
            y2_max = axisEventObject['yaxis2.range[1]'];
          }
        } else {
          //build dynamic range based on API response
          if (this.multiDT.MinY1 !== 0) {
            //overrides from CWA
            y1_min = this.multiDT.MinY1 - 1;
          } else if (
            this.multiDT.MinY1 === 0 &&
            (this.multiDT.SubjectMetric.includes('MMT') ||
              this.multiDT.SubjectMetric.includes('MMA'))
          ) {
            y1_min = 0;
          }

          if (this.multiDT.MaxY1 !== 0) {
            //overrides from CWA
            y1_max = this.multiDT.MaxY1 + 1;
          } else {
            y1_max = y1_max + y1_max * 0.1;
          }

          if (this.multiDT.MinY2 !== 0) {
            y2_min = this.multiDT.MinY2 - 1;
          } else if (
            this.multiDT.MinY2 === 0 &&
            (this.multiDT.SubjectMetric.includes('MMT') ||
              this.multiDT.SubjectMetric.includes('MMA'))
          ) {
            y2_min = 0;
          }

          if (this.multiDT.MaxY2 !== 0) {
            y2_max = this.multiDT.MaxY2 + 1;
          } else {
            y2_max = y2_max + +(y2_max * 0.1);
          }
        }
        y1_min = Math.round(y1_min);
        y1_max = Math.round(y1_max);
        y2_min = Math.round(y2_min);
        y2_max = Math.round(y2_max);
        const ticks = this.getTicks(y1_min, y1_max, y2_min, y2_max);
        return {
          'yaxis.range': ticks.y1Range,
          'yaxis2.range': ticks.y2Range,
          'yaxis.dtick': ticks.y1dTick,
          'yaxis2.dtick': ticks.y2dTick,
        };
      },
      getTicks: function (y1_min, y1_max, y2_min, y2_max) {
        const GRIDLINES = 5;

        var y1_range;
        if (y1_min < 0) {
          y1_range = y1_max - y1_min;
        } else {
          y1_range = y1_max;
        }

        y1_range = y1_range * 1000; // mult by 1000 to account for ranges < 1
        let y1_len = Math.floor(y1_range).toString().length;

        let y1_pow10_divisor = Math.pow(10, y1_len - 1);
        let y1_firstdigit = Math.floor(y1_range / y1_pow10_divisor);
        let y1_max_base = (y1_pow10_divisor * y1_firstdigit) / 1000; // div by 1000 to account for ranges < 1

        let y1_dtick = y1_max_base / GRIDLINES;

        y1_pow10_divisor = Math.pow(10, y1_len - 1) / 1000; // reset for logging purposes
        y1_range = y1_range / 1000; // range reset

        var y2_range;
        if (y2_min < 0) {
          y2_range = y2_max - y2_min;
        } else {
          y2_range = y2_max;
        }

        y2_range = y2_range * 1000; // mult by 1000 to account for ranges < 1
        let y2_len = Math.floor(y2_range).toString().length;

        let y2_pow10_divisor = Math.pow(10, y2_len - 1);
        let y2_firstdigit = Math.floor(y2_range / y2_pow10_divisor);
        let y2_max_base = (y2_pow10_divisor * y2_firstdigit) / 1000; // div by 1000 to account for ranges < 1

        let y2_dtick = y2_max_base / GRIDLINES;

        y2_pow10_divisor = Math.pow(10, y2_len - 1) / 1000; // reset for logging purposes
        y2_range = y2_range / 1000; // range reset

        /**************************************************************************/
        // Capture the highest dtick ratio as your global dtick ratio.
        //
        // All other axes will have their positive and negative ranges scaled to
        // make their dtick_ratios match the global ratio. When the ratios match,
        // the gridlines match!
        /**************************************************************************/

        var y1_dtick_ratio = Math.round(y1_range / y1_dtick);
        var y2_dtick_ratio = Math.round(y2_range / y2_dtick);

        var global_dtick_ratio = Math.round(
          Math.max(y1_dtick_ratio, y2_dtick_ratio)
        );

        /**************************************************************************/
        // Calculate Range Minimums
        //
        // 1. This is done by first finding the negative ratio for all axes:
        //     1. what percentage of the range is coming from negative values
        //     2. multiply percentage by global ratio to get the percentage of the
        //        global ratio (percentage of total gridlines) that should be shown
        //        under the zero baseline.
        //
        //     NEGATIVE RATIO == NUMBER OF GRIDLINES NEEDED FOR NEGATIVE VALUES
        //
        // 2. Capturing the highest negative ratio as the global negative ratio
        //
        // 3. Then applying the negative ratio to all of your axis minimumsto get
        //    their new proportionally scaled range minimums
        /**************************************************************************/

        var negative = false; // Are there any negative values present
        var y1_negative_ratio;
        if (y1_min < 0) {
          negative = true;
          y1_negative_ratio = Math.abs(y1_min / y1_range) * global_dtick_ratio;
        } else {
          y1_negative_ratio = 0;
        }

        var y2_negative_ratio;
        if (y2_min < 0) {
          negative = true;
          y2_negative_ratio = Math.abs(y2_min / y2_range) * global_dtick_ratio;
        } else {
          y2_negative_ratio = 0;
        }

        // Increase the ratio by 0.1 so that your range minimums are extended just
        // far enough to not cut off any part of your lowest value
        var global_negative_ratio =
          Math.max(y1_negative_ratio, y2_negative_ratio) + 0.1;

        // If any negative value is present, you must proportionally extend the
        // range minimum of all axes
        var y1_range_min;
        var y2_range_min;
        if (negative) {
          y1_range_min = global_negative_ratio * y1_dtick * -1;
          y2_range_min = global_negative_ratio * y2_dtick * -1;
        } else {
          // If no negatives, baseline is set to zero
          y1_range_min = 0;
          y2_range_min = 0;
        }

        // ************************************************************************
        // Calculate Range Maximums
        //
        // 1. This is done by first finding the positive ratio for all axes:
        //     1. what percentage of the range is coming from positive values
        //     2. multiply percentage by global ratio to get the percentage of the
        //        global ratio (percentage of total gridlines) that should be shown
        //        above the zero baseline.
        //
        //     POSITIVE RATIO == NUMBER OF GRIDLINES NEEDED FOR POSITIVE VALUES
        //
        // 2. Capturing the highest positive ratio as the global positive ratio
        //
        // 3. Then applying the positive ratio to all of your axis maximums to get
        //    their new proportionally scaled range maximums
        /**************************************************************************/

        var y1_positive_ratio =
          Math.abs(y1_max / y1_range) * global_dtick_ratio;
        var y2_positive_ratio =
          Math.abs(y2_max / y2_range) * global_dtick_ratio;

        // Increase the ratio by 0.1 so that your range maximums are extended just
        // far enough to not cut off any part of your highest value
        var global_positive_ratio =
          Math.max(y1_positive_ratio, y2_positive_ratio) + 0.1;

        var y1_range_max = global_positive_ratio * y1_dtick;
        var y2_range_max = global_positive_ratio * y2_dtick;

        return {
          y1Range: [y1_range_min, y1_range_max],
          y1dTick: y1_dtick,
          y2Range: [y2_range_min, y2_range_max],
          y2dTick: y2_dtick,
        };
      },
    },
  };
</script>
